export default "//static.tradera.net/touchweb/static/output/images/category-mobile-phone-telecommunications.9b71aad1.svg";